module.exports = __webpack_public_path__ + "static/media/tile_menu_icon_e_concierge.26e401ec.png";